import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { canChangeOmniPIN } from '../../../modules/account/selectors';
import Translation from '../../i18n/Translation';
import withOmni from '../../withOmni';

const openSetPINPage = () => {
  window.open(api_config.online_set_pin_url, '_blank');
  return false;
};

export const SetPIN = ({ canChangePIN }) => (
  <div className="set-pin">
    <div className="set-pin__box container--fixed">
      <h2 className="set-pin__title">
        <Translation section="onlinePIN" label="title" />
      </h2>
      <p className="set-pin__paragraph">
        <Translation
          section="onlinePIN"
          label={canChangePIN ? 'descriptionChange' : 'descriptionSet'}
        />
      </p>
      <Button className="set-pin__button" onClick={openSetPINPage}>
        <Translation
          section="onlinePIN"
          label={canChangePIN ? 'submitChange' : 'submitSet'}
        />
        <Translation section="onlinePIN" label="submit" />
      </Button>
    </div>
  </div>
);

SetPIN.propTypes = {
  canChangePIN: PropTypes.bool
};

const mapStateToProps = state => ({
  canChangePIN: canChangeOmniPIN(state)
});

export default withOmni(connect(mapStateToProps)(SetPIN));
